module.exports = __webpack_public_path__ + "e5463d1bd784c3a71d89ed36934e96e6.jpg";